import React, {useState, useEffect } from "react";

import { API_BASE } from "../config";

/* =========================
   BENEFICIAIRES (ta page CRUD)
========================= */
export function BeneficiairesCollectivite({ user }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const [q, setQ] = useState("");
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const limit = 20;

  const [editModal, setEditModal] = useState(null);
  // { mode:'create'|'edit', data?: {id, code, email, statut, nom, prenom, telephone} }

  const [confirmModal, setConfirmModal] = useState(null);
  // { type:'toggle'|'delete', id, code, email, nextStatut? }

  const [form, setForm] = useState({
    nom: "",
    prenom: "",
    telephone: "",
    email: "",
  });

  const [phoneError, setPhoneError] = useState("");
  const [emailError, setEmailError] = useState("");



  const pages = Math.max(1, Math.ceil(total / limit));

  const authHeaders = React.useMemo(
    () => ({
      "Content-Type": "application/json",
      Authorization: `Bearer ${user?.token}`,
    }),
    [user?.token]
  );
  const [toast, setToast] = useState({ type: "", msg: "" });
  

  const resetMessages = () => {
    setError("");
    setSuccess("");
  };

  const flashSuccess = (msg) => {
    setSuccess(msg);
    setTimeout(() => setSuccess(""), 4000);
  };
  const showToast = (type, msg) => {
    setToast({ type, msg });
    setTimeout(() => setToast({ type: "", msg: "" }), 3200);
  };

  const fetchBeneficiaires = async (overridePage) => {
    setLoading(true);
    resetMessages();
    const nextPage = overridePage ?? page;

    try {
      const params = new URLSearchParams();
      params.set("page", String(nextPage));
      params.set("limit", String(limit));
      if (q.trim()) params.set("q", q.trim());

      const res = await fetch(`${API_BASE}/collectivite/beneficiaires?${params.toString()}`, {
        headers: authHeaders,
        
      });

      const data = await res.json().catch(() => ({}));

      if (!res.ok) {
        setError(data.msg || "Erreur lors du chargement des bénéficiaires");
      } else {
        setItems(data.items || []);
        setTotal(data.total || 0);
      }
    } catch {
      setError("Impossible de contacter le serveur.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBeneficiaires();
    // eslint-disable-next-line
  }, [page]);

  // Recherche automatique avec debounce (300ms)
  useEffect(() => {
    const timer = setTimeout(() => {
      setPage(1);
      fetchBeneficiaires(1);
    }, 300);
    return () => clearTimeout(timer);
    // eslint-disable-next-line
  }, [q]);

  const openCreate = () => {
    resetMessages();
    setForm({ nom: "", prenom: "", telephone: "", email: "" });
    setEditModal({ mode: "create" });
  };

  const openEdit = (b) => {
    resetMessages();
    setForm({
      nom: b.nom || "",
      prenom: b.prenom || "",
      telephone: b.telephone || "",
      email: b.email || "",
    });
    setEditModal({ mode: "edit", data: b });
  };

  const formatPhoneToInternational = (phone) => {
    if (!phone) return "";

    const digits = phone.replace(/\s/g, "");

    if (digits.startsWith("0")) {
      return "+33" + digits.substring(1);
    }

    return digits;
  };

  const saveBeneficiaire = async () => {
    resetMessages();
    setPhoneError("");
    setEmailError("");

    if (!form.nom.trim()) {
      setError("Le nom est obligatoire");
      return;
    }
    if (!form.prenom.trim()) {
      setError("Le prénom est obligatoire");
      return;
    }

    const email = form.email.trim();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (email && !emailRegex.test(email)) {
      setEmailError("Email invalide");
      return;
    }

  const digits = form.telephone.replace(/\s/g, "");
  const phoneFormatted = formatPhoneToInternational(digits);

  if (!digits) {
    setPhoneError("Le téléphone est obligatoire");
    return;
  }

  if (digits.length > 0 && digits.length < 10) {
    setPhoneError("Numéro invalide (renseigner 10 chiffres)");
    return;
  }

  if (digits.length === 10 && !digits.startsWith("06") && !digits.startsWith("07")) {
    setPhoneError("Numéro invalide (le numéro doit commencer par 06 ou 07)");
    return;
  }
  const isEdit = editModal?.mode === "edit";
  const id = editModal?.data?.id;

  try {
    const url = isEdit
      ? `${API_BASE}/collectivite/beneficiaires/${id}`
      : `${API_BASE}/collectivite/beneficiaires`;

    const method = isEdit ? "PATCH" : "POST";

    const res = await fetch(url, {
      method,
      headers: authHeaders,
      body: JSON.stringify({
        email: form.email.trim(),
        nom: form.nom.trim(),
        prenom: form.prenom.trim(),
        telephone: phoneFormatted,
      }),
    });

    const data = await res.json().catch(() => ({}));

    if (!res.ok) {
      setError(data.msg || "Erreur lors de l'enregistrement");
      return;
    }

    setEditModal(null);
    flashSuccess(
      isEdit
        ? "Bénéficiaire modifié avec succès"
        : "Bénéficiaire créé avec succès"
    );

    if (!isEdit) setPage(1);
    await fetchBeneficiaires(!isEdit ? 1 : page);
  } catch {
    setError("Impossible de contacter le serveur.");
  }
};


  const askToggleStatut = (b) => {
    resetMessages();
    const nextStatut = b.statut === "ACTIF" ? "INACTIF" : "ACTIF";
    setConfirmModal({
      type: "toggle",
      id: b.id,
      code: b.code,
      email: b.email,
      nextStatut,
    });
  };



  const doToggleStatut = async () => {
    if (!confirmModal || confirmModal.type !== "toggle") return;

    try {
      const res = await fetch(`${API_BASE}/collectivite/beneficiaires/${confirmModal.id}/statut`, {
        method: "PATCH",
        headers: authHeaders,

        body: JSON.stringify({ statut: confirmModal.nextStatut }),
      });

      const data = await res.json().catch(() => ({}));

      if (!res.ok) {
        setError(data.msg || "Erreur mise à jour statut");
      } else {
        setItems((prev) =>
          prev.map((x) => (x.id === confirmModal.id ? { ...x, statut: confirmModal.nextStatut } : x))
        );
        flashSuccess("Statut mis à jour");
      }
    } catch {
      setError("Impossible de contacter le serveur.");
    } finally {
      setConfirmModal(null);
    }
  };

  const doDelete = async () => {
    if (!confirmModal || confirmModal.type !== "delete") return;

    try {
      const res = await fetch(`${API_BASE}/collectivite/beneficiaires/${confirmModal.id}`, {
        method: "DELETE",
        headers: authHeaders,
      });

      const data = await res.json().catch(() => ({}));

      if (!res.ok) {
        setError(data.msg || "Erreur suppression");
      } else {
        setItems((prev) =>
          prev.map((x) => (x.id === confirmModal.id ? { ...x, statut: "INACTIF" } : x))
        );
        flashSuccess("Bénéficiaire désactivé avec succès");
      }
    } catch {
      setError("Impossible de contacter le serveur.");
    } finally {
      setConfirmModal(null);
    }
  };

  return (
    <div className="adminPanel">
      <div className="adminPanelHeader">
        <div>
      
        </div>

        <div style={{ display: "flex", gap: 10, alignItems: "center" }}>

        <button
          className="btnSecondary"
          onClick={async () => {
            setQ("");
            setPage(1);
            await fetchBeneficiaires(1);
            showToast("success", "Bénéficiaires mis à jour");
          }}
          disabled={loading}
        >
            {loading ? "Chargement..." : "Rafraîchir"}
          </button>
         

          <button className="btnPrimary" onClick={openCreate}>
            + Ajouter
          </button>
        </div>
      </div>

      <div className="adminToolbar">
        <input
          className="adminInput"
          placeholder="Rechercher par nom ou prénom…"
          value={q}
          onChange={(e) => setQ(e.target.value)}
        />
      </div>

      {error && <div className="adminError">{error}</div>}
      {success && <div className="adminSuccess">{success}</div>}

      <div className="adminTableWrap">
        <table className="adminTable">
          <thead>
            <tr>
              <th>Code</th>
              <th>Email</th>
              <th>Nom</th>
              <th>Prénom</th>
              <th>Téléphone</th>
              <th>Statut</th>
              <th style={{ width: 200 }}>Actions</th>
            </tr>
          </thead>

          <tbody>
            {!loading && items.length === 0 && (
              <tr>
                <td colSpan={7} className="adminMonoo">
                  Aucun bénéficiaire.
                </td>
              </tr>
            )}

            {items.map((b) => (
           <tr key={b.id}>
           <td className="adminMono" data-label="Code">{b.code}</td>
           <td className="adminMono" data-label="Email">{b.email || "—"}</td>
           <td className="adminMono" data-label="Nom">{b.nom || "—"}</td>
           <td className="adminMono" data-label="Prénom">{b.prenom || "—"}</td>
           <td className="adminMono" data-label="Téléphone">{b.telephone || "—"}</td>
           <td data-label="Statut">
             <span className={`statusBadge ${b.statut === "ACTIF" ? "on" : "off"}`}>
               {b.statut === "ACTIF" ? "Actif" : "Inactif"}
             </span>
           </td>
           <td data-label="Actions" className="benefActionsCell">
             <button className="editButton" onClick={() => openEdit(b)}>
               Modifier
             </button>
             <button
               className={`toggleBtn ${b.statut === "ACTIF" ? "on" : "off"}`}
               onClick={() => askToggleStatut(b)}
             >
               {b.statut === "ACTIF" ? "Désactiver" : "Activer"}
             </button>
           </td>
          </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="adminPager">
        <button className="btnSecondary" onClick={() => setPage((p) => Math.max(1, p - 1))} disabled={page === 1}>
          ←
        </button>

        <div className="adminPagerInfo">
          Page <b>{page}</b> / {pages} — Total: <b>{total}</b>
        </div>

        <button className="btnSecondary" onClick={() => setPage((p) => Math.min(pages, p + 1))} disabled={page >= pages}>
          →
        </button>
      </div>

      {/* Modal create/edit */}
      {editModal && (
        <div className="logoutModalOverlay">
          <div className="logoutModal" style={{ maxWidth: 520 }}>
            <div className="logoutModalTitle">
              {editModal.mode === "edit" ? "Modifier un bénéficiaire" : "Ajouter un bénéficiaire"}
            </div>
            <div className="logoutModalText">Renseignez les informations ci-dessous.</div>

            <div style={{ marginTop: 14, display: "grid", gap: 10 }}>
              <input
                className="adminInput"
                placeholder="Nom"
                value={form.nom}
                onChange={(e) => setForm((s) => ({ ...s, nom: e.target.value }))}
              />
              <input
                className="adminInput"
                placeholder="Prénom"
                value={form.prenom}
                onChange={(e) => setForm((s) => ({ ...s, prenom: e.target.value }))}
              />
          <input
            className="adminInput"
            placeholder="06XXXXXXXX"
            value={form.telephone}
            maxLength={10}
            onChange={(e) => {
              let value = e.target.value.replace(/\D/g, ""); // seulement chiffres

              if (value.length > 10) {
                value = value.slice(0, 10);
              }

              // Empêcher les numéros qui ne commencent pas par 06 ou 07
              if (value.length >= 2) {
                const prefix = value.slice(0, 2);
                if (prefix !== "06" && prefix !== "07") {
                  setPhoneError("Le numéro doit commencer par 06 ou 07");
                } else {
                  setPhoneError("");
                }
              }

              setForm((s) => ({ ...s, telephone: value }));
            }}
          />


              {phoneError && (
                <div style={{ color: "#e74c3c", fontSize: 13 }}>
                  {phoneError}
                </div>
              )}

              <input
                className="adminInput"
                placeholder="email@domaine.fr"
                value={form.email}
                onChange={(e) => {
                  setForm((s) => ({ ...s, email: e.target.value }));
                  setEmailError(""); 
                }} 
              />
              {emailError && (
                <div style={{ color: "#e74c3c", fontSize: 13 }}>
                  {emailError}
                </div>
              )}

            </div>

            <div className="logoutModalActions">
              <button className="btnSecondary" onClick={() => setEditModal(null)}>
                Annuler
              </button>
              <button className="btnPrimary" onClick={saveBeneficiaire}>
                Enregistrer
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Confirm modal (toggle + delete) */}
      {confirmModal && (
        <div className="logoutModalOverlay">
          <div className="logoutModal">
            <div className="logoutModalTitle">Confirmation</div>

            <div className="logoutModalText">
              {confirmModal.type === "toggle"
                ? confirmModal.nextStatut === "ACTIF"
                  ? `Activer ${confirmModal.code} (${confirmModal.email}) ?`
                  : `Désactiver ${confirmModal.code} (${confirmModal.email}) ?`
                : `Supprimer (désactiver) ${confirmModal.code} (${confirmModal.email}) ?`}
            </div>

            <div className="logoutModalActions">
              <button className="btnSecondary" onClick={() => setConfirmModal(null)}>
                Annuler
              </button>

              <button className="btnDanger" onClick={confirmModal.type === "toggle" ? doToggleStatut : doDelete}>
                Confirmer
              </button>
            </div>
          </div>
        </div>
      )}
      {toast.msg && (
  <div className={`adminToast ${toast.type}`}>
    {toast.msg}
  </div>
)}
    </div>

  );
}